export const testimonialSlider = () => {

    console.log("Kundenstimmen Slider init");
    
    const items = document.querySelectorAll('.testiomonial-slider-item');
    const itemCount = items.length;
    const nextItem = document.querySelectorAll('.next');

    let count = 0;



    function showNextItem() {
        items[count].classList.remove('active');

        if(count < itemCount - 1) {
            count++;
        } else {
            count = 0;
        }
        items[count].classList.add('active'); 
    }

    nextItem.forEach(next => {
        next.addEventListener('click', showNextItem);
    });
}